/**
 * Installation address block: adapts the form to the selected country and
 * persists it to the cart. Checkout gating is handled declaratively by
 * cart-checkout-gate.js.
 *
 * External module for the same reason as the gate: the cart drawer morphs
 * its contents in, and morphed HTML does not execute inline scripts.
 */
(function () {
  // Checkout gating is handled declaratively by cart-checkout-gate. This
  // script adapts the address form to the selected country and persists
  // it to the cart. Guarded because the cart section can be re-rendered.
  if (window.cartWarrantyAddressPersist) return;
  window.cartWarrantyAddressPersist = true;

  // Postal code rules by country name, matching the values Shopify emits
  // in country_option_tags. Anything not listed falls back to GENERIC,
  // which only rules out junk. Add a country here to tighten it up.
  var POSTAL_RULES = {
    'United States': { pattern: '[0-9]{5}(-[0-9]{4})?', message: 'Enter a 5-digit ZIP code.', label: 'ZIP Code', maxlength: 10 },
    'Canada': { pattern: '[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]', message: 'Enter a postal code like K1A 0B1.', label: 'Postal Code', maxlength: 7 },
    'United Kingdom': { pattern: '[A-Za-z]{1,2}[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}', message: 'Enter a postcode like SW1A 1AA.', label: 'Postcode', maxlength: 8 },
    'Ireland': { pattern: '[A-Za-z0-9]{3} ?[A-Za-z0-9]{4}', message: 'Enter an Eircode like D02 AF30.', label: 'Eircode', maxlength: 8 },
    'Australia': { pattern: '[0-9]{4}', message: 'Enter a 4-digit postcode.', label: 'Postcode', maxlength: 4 },
    'New Zealand': { pattern: '[0-9]{4}', message: 'Enter a 4-digit postcode.', label: 'Postcode', maxlength: 4 },
    'Germany': { pattern: '[0-9]{5}', message: 'Enter a 5-digit postal code.', label: 'Postal Code', maxlength: 5 },
    'France': { pattern: '[0-9]{5}', message: 'Enter a 5-digit postal code.', label: 'Postal Code', maxlength: 5 },
    'Spain': { pattern: '[0-9]{5}', message: 'Enter a 5-digit postal code.', label: 'Postal Code', maxlength: 5 },
    'Italy': { pattern: '[0-9]{5}', message: 'Enter a 5-digit postal code.', label: 'Postal Code', maxlength: 5 },
    'Mexico': { pattern: '[0-9]{5}', message: 'Enter a 5-digit postal code.', label: 'Postal Code', maxlength: 5 },
    'Netherlands': { pattern: '[0-9]{4} ?[A-Za-z]{2}', message: 'Enter a postal code like 1012 AB.', label: 'Postal Code', maxlength: 7 },
    'Japan': { pattern: '[0-9]{3}-?[0-9]{4}', message: 'Enter a postal code like 100-0001.', label: 'Postal Code', maxlength: 8 },
    'India': { pattern: '[0-9]{6}', message: 'Enter a 6-digit PIN code.', label: 'PIN Code', maxlength: 6 },
    'Brazil': { pattern: '[0-9]{5}-?[0-9]{3}', message: 'Enter a CEP like 01310-100.', label: 'CEP', maxlength: 9 },
    'Poland': { pattern: '[0-9]{2}-?[0-9]{3}', message: 'Enter a postal code like 00-001.', label: 'Postal Code', maxlength: 6 },
    'Sweden': { pattern: '[0-9]{3} ?[0-9]{2}', message: 'Enter a postal code like 111 22.', label: 'Postal Code', maxlength: 6 },
    'Switzerland': { pattern: '[0-9]{4}', message: 'Enter a 4-digit postal code.', label: 'Postal Code', maxlength: 4 },
    'Austria': { pattern: '[0-9]{4}', message: 'Enter a 4-digit postal code.', label: 'Postal Code', maxlength: 4 },
    'Belgium': { pattern: '[0-9]{4}', message: 'Enter a 4-digit postal code.', label: 'Postal Code', maxlength: 4 },
    'Denmark': { pattern: '[0-9]{4}', message: 'Enter a 4-digit postal code.', label: 'Postal Code', maxlength: 4 },
    'Norway': { pattern: '[0-9]{4}', message: 'Enter a 4-digit postal code.', label: 'Postal Code', maxlength: 4 }
  };

  var GENERIC_POSTAL = {
    pattern: '[\\p{L}0-9][\\p{L}0-9 \\-]{1,10}',
    message: 'Enter a valid postal code.',
    label: 'Postal Code',
    maxlength: 12
  };

  // Countries that do not use postal codes - the field is hidden, and the
  // gate skips hidden fields, so nothing is demanded of these customers.
  var NO_POSTAL_CODE = [
    'Angola', 'Antigua & Barbuda', 'Aruba', 'Bahamas', 'Belize', 'Benin', 'Botswana',
    'Burkina Faso', 'Burundi', 'Cameroon', 'Central African Republic', 'Chad', 'Comoros',
    'Congo - Brazzaville', 'Congo - Kinshasa', 'Cook Islands', 'Côte d’Ivoire', 'Curaçao',
    'Djibouti', 'Dominica', 'Equatorial Guinea', 'Eritrea', 'Fiji', 'Gambia', 'Ghana',
    'Grenada', 'Guyana', 'Hong Kong SAR', 'Jamaica', 'Kenya', 'Kiribati', 'Libya', 'Macao SAR',
    'Malawi', 'Mali', 'Mauritania', 'Mauritius', 'Montserrat', 'Nauru', 'Niue',
    'North Korea', 'Panama', 'Qatar', 'Rwanda', 'Samoa', 'São Tomé & Príncipe',
    'Saudi Arabia', 'Seychelles', 'Sierra Leone', 'Solomon Islands', 'Somalia',
    'South Africa', 'St. Kitts & Nevis', 'St. Lucia', 'Suriname', 'Syria', 'Tanzania',
    'Timor-Leste', 'Tokelau', 'Tonga', 'Trinidad & Tobago', 'Tuvalu', 'Uganda',
    'United Arab Emirates', 'Vanuatu', 'Yemen', 'Zimbabwe'
  ];

  // Shopify's own province labels, so the field reads naturally.
  var STATE_LABELS = {
    'United States': 'State',
    'Canada': 'Province',
    'Australia': 'State/Territory',
    'Ireland': 'County',
    'India': 'State',
    'Italy': 'Province',
    'Japan': 'Prefecture',
    'Mexico': 'State',
    'Brazil': 'State',
    'China': 'Province',
    'Spain': 'Province'
  };

  function section() {
    return document.getElementById('cart-warranty-section');
  }

  function setLabel(labelId, text) {
    var label = document.getElementById(labelId);
    if (label) label.innerHTML = text + ' <span aria-hidden="true">*</span>';
  }

  // Fill the province dropdown from the country's data-provinces, keeping
  // whatever the customer had already chosen where it still applies.
  function renderProvinces(country, provinces) {
    var field = document.getElementById('warranty-state-field');
    var select = document.getElementById('warranty-state');
    if (!field || !select) return;

    if (!provinces.length) {
      field.hidden = true;
      select.innerHTML = '';
      return;
    }

    var previous = select.value || select.getAttribute('data-saved-state') || '';
    var normalized = previous.trim().toLowerCase();

    var html = '<option value="">Select a ' + (STATE_LABELS[country] || 'region').toLowerCase() + '</option>';
    provinces.forEach(function (province) {
      // Shopify emits [value, label] pairs; match a saved value against
      // either, so an address stored as "TX" or "Texas" still selects.
      var value = province[0];
      var label = province[1] || province[0];
      var selected =
        normalized && (String(value).toLowerCase() === normalized || String(label).toLowerCase() === normalized);
      html +=
        '<option value="' + value + '"' + (selected ? ' selected' : '') + '>' + label + '</option>';
    });

    select.innerHTML = html;
    field.hidden = false;
    setLabel('warranty-state-label', STATE_LABELS[country] || 'State / Province / Region');
  }

  function applyPostalRule(country) {
    var field = document.getElementById('warranty-zip-field');
    var input = document.getElementById('warranty-zip');
    if (!field || !input) return;

    if (NO_POSTAL_CODE.indexOf(country) !== -1) {
      field.hidden = true;
      input.value = '';
      return;
    }

    var rule = POSTAL_RULES[country] || GENERIC_POSTAL;
    field.hidden = false;
    input.setAttribute('data-checkout-gate-pattern', rule.pattern);
    input.setAttribute('data-checkout-gate-message', rule.message);
    input.setAttribute('maxlength', rule.maxlength);
    setLabel('warranty-zip-label', rule.label);
  }

  function onCountryChange() {
    var select = document.getElementById('warranty-country');
    if (!select) return;

    var country = select.value;
    var option = select.options[select.selectedIndex];
    var provinces = [];

    if (option) {
      try {
        provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
      } catch (e) {
        provinces = [];
      }
    }

    renderProvinces(country, provinces);
    applyPostalRule(country);

    // Field visibility changed, so let the gate re-evaluate.
    if (window.cartCheckoutGate) window.cartCheckoutGate.sync();
  }

  // Saved as cart attributes while the customer types (debounced), so
  // the address survives cart updates re-rendering the section.
  var timer = null;

  function persist(e) {
    var el = section();
    if (!el || !el.contains(e.target)) return;

    clearTimeout(timer);
    timer = setTimeout(function () {
      var attributes = {};
      var fields = el.querySelectorAll(
        'input[name^="attributes["], select[name^="attributes["]'
      );
      fields.forEach(function (input) {
        var key = input.name.slice(11, -1); // strip attributes[ ... ]
        attributes[key] = input.value;
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {
        /* non-fatal; the form submit still saves the attributes */
      });
    }, 600);
  }

  document.addEventListener('input', persist);
  document.addEventListener('change', persist); // the dropdowns

  document.addEventListener('change', function (e) {
    if (e.target.id === 'warranty-country') onCountryChange();
  });

  // Idempotent: the block may not exist at page load (an empty cart), and
  // arrives later as morphed markup. A morphed select is a NEW element
  // without the marker, so it gets initialised then; re-running otherwise
  // is a getElementById and a dataset read.
  function init() {
    var select = document.getElementById('warranty-country');
    if (!select || select.dataset.warrantyInit === 'true') return;
    select.dataset.warrantyInit = 'true';

    // Select the saved country, or the shop/market default.
    if (!select.value) {
      var wanted = (select.getAttribute('data-default-country') || '').trim().toLowerCase();
      Array.prototype.slice.call(select.options).forEach(function (option) {
        if (option.value.trim().toLowerCase() === wanted) option.selected = true;
      });
    }

    onCountryChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:update', function () {
    requestAnimationFrame(init);
  });

  // Backstop for any path that swaps the cart in without firing cart:update
  // (the drawer rendering its first item, for one). Cheap because init()
  // bails immediately once the current select is marked.
  if (typeof MutationObserver === 'function') {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        init();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
